import { render } from "./LiberiaChapterContent.vue?vue&type=template&id=7e8b47c8&scoped=true&ts=true"
import script from "./LiberiaChapterContent.vue?vue&type=script&lang=ts"
export * from "./LiberiaChapterContent.vue?vue&type=script&lang=ts"

import "./LiberiaChapterContent.vue?vue&type=style&index=0&id=7e8b47c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e8b47c8"]])

export default __exports__